/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import styled from 'styled-components';
import StyledProps from '../common/theme/AppThemeInterface';
import Switch, { SwitchProps } from '@mui/material/Switch';

export interface SwitchOnOffProps extends SwitchProps {
  labelOn: string;
  labelOff: string;
  width: number;
  thumbSize: number;
}

const SwitchOnOff = styled((props: SwitchOnOffProps) => {
  const { labelOn, labelOff, width, thumbSize, ...rest } = props;
  return <Switch {...rest} />;
})`
  width: ${({ width }: SwitchOnOffProps) => width}px;
  margin-right: 10px;

  .checked {
    color: #21ecff;
    transform: translateX(${({ width, thumbSize }: SwitchOnOffProps) => width - thumbSize * 2}px);
  }

  .thumb {
    width: ${({ thumbSize }: SwitchOnOffProps) => thumbSize}px;
    height: ${({ thumbSize }: SwitchOnOffProps) => thumbSize}px;
  }

  .track {
    height: 16px;
    font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
    font-size: 10px;
    line-height: 16px;
    padding: 0 10px;
    color: #ffffff;
    background-color: #979797;
    opacity: 1;
    text-align: right;
  }

  .track:before {
    content: '${({ labelOff }: SwitchOnOffProps) => labelOff}';
  }

  .checked + .track {
    background-color: #25b0be;
    text-align: left;
    opacity: 1;
  }

  .checked + .track:before {
    content: '${({ labelOn }: SwitchOnOffProps) => labelOn}';
  }
`;

SwitchOnOff.defaultProps = {
  labelOn: 'ON',
  labelOff: 'OFF',
  width: 74,
  thumbSize: 21,
  classes: {
    checked: 'checked',
    track: 'track',
    thumb: 'thumb',
  },
};

export default SwitchOnOff;
